(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mercat-bp-v3"] && !Shopify.designMode) return;
  try {
    class MercatBPPage extends HTMLElement { connectedCallback(){if(this.ready)return;this.ready=true;const buy=this.querySelector('.buy');this.querySelectorAll('[data-scroll-buy]').forEach(b=>b.addEventListener('click',()=>{buy.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});this.querySelector('[name=quantity]').focus({preventScroll:true});}));this.observer=new IntersectionObserver(entries=>{this.querySelector('.bar').classList.toggle('show',entries[0].boundingClientRect.bottom<0)});this.observer.observe(buy);} disconnectedCallback(){this.observer?.disconnect();this.ready=false;}} if(!customElements.get('mercat-bp-page'))customElements.define('mercat-bp-page',MercatBPPage);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mercat-carebox-pro"] && !Shopify.designMode) return;
  try {
    
class MercatCarebox extends HTMLElement {
 connectedCallback(){if(this.initialized)return;this.initialized=true;this.abort=new AbortController();const options={signal:this.abort.signal};const track=this.querySelector('.mcb-track');const thumbs=[...this.querySelectorAll('[data-slide]')];const qty=this.querySelector('[name="quantity"]');const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
 thumbs.forEach(button=>button.addEventListener('click',()=>{track.scrollTo({left:Number(button.dataset.slide)*track.clientWidth,behavior:reduced()?'instant':'smooth'});},options));
 let frame=0;track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{const current=Math.round(track.scrollLeft/track.clientWidth);thumbs.forEach((b,i)=>{if(i===current)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');});});},{...options,passive:true});
 this.querySelectorAll('[data-quantity-change]').forEach(b=>b.addEventListener('click',()=>{if(!qty.value)qty.value=qty.min||'1';if(Number(b.dataset.quantityChange)>0)qty.stepUp();else qty.stepDown();qty.dispatchEvent(new Event('change',{bubbles:true}));},options));
 this.querySelector('[data-variant-select]')?.addEventListener('change',event=>{const url=new URL(location.href);url.searchParams.set('variant',event.target.value);location.assign(url.toString());},options);
const buyNow=this.querySelector('[data-buy-now]');

buyNow?.addEventListener('click',async()=>{
  const variantId=this.querySelector('[name="id"]')?.value;
  const quantity=this.querySelector('[name="quantity"]')?.value||1;

  if(!variantId)return;

  buyNow.disabled=true;

  try{
    const response=await fetch('/cart/add.js',{
      method:'POST',
      headers:{
        'Content-Type':'application/json',
        'Accept':'application/json'
      },
      body:JSON.stringify({
        items:[{
          id:Number(variantId),
          quantity:Number(quantity)
        }]
      })
    });

    if(!response.ok)throw new Error('Unable to add product');

    window.location.href='/checkout';

  }catch(error){
    console.error(error);
    buyNow.disabled=false;
  }
});
}
 disconnectedCallback(){this.abort?.abort();this.initialized=false;}
}if(!customElements.get('mercat-carebox'))customElements.define('mercat-carebox',MercatCarebox);

  } catch(e) { console.error(e); }
})();
})();
